module.exports = {
        srcSet: __webpack_public_path__ + "762f7722cf864447-600.webp"+" 600w"+","+__webpack_public_path__ + "983a2b5774398e53-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "762f7722cf864447-600.webp",width: 600,height: 341},{path: __webpack_public_path__ + "983a2b5774398e53-1000.webp",width: 1000,height: 568}],
        src: __webpack_public_path__ + "983a2b5774398e53-1000.webp",
        toString: function(){return __webpack_public_path__ + "983a2b5774398e53-1000.webp"},
        
        width: 1000,
        height: 568
      }